export const ACCURACY_THRESHOLD_HIGH = 80467.2;
export const ACCURACY_THRESHOLD_LOW = 804.672;

export const ACCURACIES = {
  LOW: "LOW",
  MEDIUM: "MEDIUM",
  HIGH: "HIGH",
};

export const API_ENDPOINTS = {
  LOCALIZATION_SERVICE: "/LocalizationService/v1/localstore",
  STORE_SEARCH_SERVICE: "/StoreSearchServices/v2/storesearch",
  LOCATION_SERVICE: "/StoreSearchServices/v2/location"
};

export const DOMAINS = {
  DEV: "hd-qa71.homedepotdev.com",
  STAGE: "hd-qa74.homedepotdev.com",
  PROD: "homedepot.com",
};

export const THD_LOCALIZER = "THD_LOCALIZER";

export const STORAGE_IDENTIFIERS = {
  AUTHORIZED_GEOLOCATION: "authorizedGeoLocation",
  DELIVERY_ZIP: "DELIVERY_ZIP",
  DELIVERY_ZIP_TYPE: "DELIVERY_ZIP_TYPE",
  GPS_STATUS: "GPS_STATUS",
  IN_STORE_API_SESSION: "IN_STORE_API_SESSION",
  IN_STORE_USER_NUMBER: "IN_STORE_USER_NUMBER",
  LOCALIZATION_METHOD: "localizationMethod",
  NATIVE_LOCALIZED_STORE: "NATIVE_LOCALIZED_STORE",
  THD_AUTOLOCINTERCEPT: "THD_AUTOLOCINTERCEPT",
  THD_CA_USER: "THD_CA_USER",
  THD_INSTORE: "THD_INSTORE",
  [THD_LOCALIZER]: {
    THD_STRFINDERZIP: "THD_STRFINDERZIP",
    THD_STORE_HOURS_EXPIRY: "THD_STORE_HOURS_EXPIRY",
    THD_STORE_HOURS: "THD_STORE_HOURS",
    THD_LOCSTORE: "THD_LOCSTORE",
    THD_INTERNAL: "THD_INTERNAL",
    THD_FORCE_LOC: "THD_FORCE_LOC",
    WORKFLOW: "WORKFLOW",
  },
};

export const CATEGORIES = {
  AUTHORIZED_GEOLOCATION: { UNAUTHORIZED: "0" },
  THD_FORCE_LOC: {
    SELF_LOCALIZED: "0",
    AUTO_LOCALIZED: "1",
    DEFAULT: "2",
  },
  THD_INTERNAL: {
    EXTERNAL: "0",
    INTERAL: "1",
  },
};

export const DAYS = [
  "sunday",
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
];

export const DEFAULT_STORE = {
  storeId: "121",
  name: "Cumberland",
  address: {
    postalCode: "30339",
    county: "Cobb",
    state: "GA",
    country: "US",
    city: "Atlanta",
    street: "2450 Cumberland Pkwy",
  },
  storeHours: {
    monday: { open: "6:00", close: "22:00" },
    tuesday: { open: "6:00", close: "22:00" },
    wednesday: { open: "6:00", close: "22:00" },
    thursday: { open: "6:00", close: "22:00" },
    friday: { open: "6:00", close: "22:00" },
    saturday: { open: "6:00", close: "22:00" },
    sunday: { open: "8:00", close: "20:00" },
  },
};

export const DELIVERY_ZIP_TYPES = {
  AUTO: "AUTO",
  DEFAULT: "DEFAULT",
  USER: "USER",
  LOGIN: "LOGIN",
};

export const EVENTS = {
  LOCALIZED_BY_IP: "localized_by_ip",
  LOCALIZED_BY_GPS: "localized_by_gps",
  LOCALIZED_BY_DEFAULT: "localize_default",
  LOCALIZED_BY_STORE: "localized_by_store",
  LOCALIZED_BY_ZIPCODE: "localized_by_zipcode",
  LOCALIZED_STORE_CHANGE_GOOGLE: "localized_store_change_google",
  LOCALIZED_STORE_CHANGED: "localized_store_changed",
  LOCALIZED: "localize_complete",
  LOCALIZE_BY_STORE_FAILED: "localize_by_store_failed",
  LOCALIZE_BY_ZIPCODE_FAILED: "localize_by_zipcode_failed",
  LOCALIZE_BY_IP_FAILED: "localize_by_ip_failed",
  USER_DENIED_GPS: "user_denied_gps",
  GPS_ERROR: "gps_error",
  GPS_TIMEOUT: "gps_position_aquisition_timeout",
  DELIVERY_ZIP_UPDATED: "delivery_zip_updated",
};

export const MESSAGES = {
  GPS_ERROR: "gps error",
  GPS_TIMEOUT: "gps timeout",
  USER_DENIED_GPS: "gps access denied",
};

export const LIFECYCLE_EVENTS = {
  LOCALIZED: "LOCALIZATION.localized",
};

export const RADIUS = {
  IN_STORE_MILE_RADIUS: "0.135531538772583",
  MAX_POSSIBLE_MILE_RADIUS: "621.371",
  SOFT_LINK_MIN_MILE_RADIUS: "50",
  SOFT_LINK_MAX_MILE_RADIUS: "200",
};

export const TIMEOUT = 5000;

const WORKFLOW_ALIASES = {
  DEFAULT: "Default",
  GPS_HIGH: "gps/html5/wi-fi|high",
  GPS_LOW: "gps/html5/wi-fi|low",
  GPS_MEDIUM: "gps/html5/wi-fi|med",
  IP_DB_CORPORATE: "IP-DB:Corporate",
  IP_DB_DEFAULT_INTERNAL: "IP-DB:Default Internal",
  IP_DB_HISTORY: "IP-DB:History",
  IP_DB_SELF_LOCALIZED: "IP-DB:Self Localized",
  IP_DB_SIMILAR_HISTORY: "IP-DB:Similar History",
  IP_DB_STORE: "IP-DB:Store",
  IP_DB_VENDOR: "IP-DB:Vendor",
};

export const WORKFLOW_MAP = {
  LOCALIZED_BY_GPS_HIGH: {
    accuracy: ACCURACIES.HIGH,
    alias: WORKFLOW_ALIASES.GPS_HIGH,
    category: CATEGORIES.THD_FORCE_LOC.AUTO_LOCALIZED,
  },
  LOCALIZED_BY_STORE: {
    accuracy: ACCURACIES.HIGH,
    alias: WORKFLOW_ALIASES.IP_DB_SELF_LOCALIZED,
    category: CATEGORIES.THD_FORCE_LOC.SELF_LOCALIZED,
  },
  LOCALIZED_BY_FUZZY_STORE: {
    accuracy: ACCURACIES.MEDIUM,
    alias: WORKFLOW_ALIASES.IP_DB_SELF_LOCALIZED,
    category: CATEGORIES.THD_FORCE_LOC.SELF_LOCALIZED,
  },
  LOCALIZED_BY_ZIPCODE: {
    accuracy: ACCURACIES.MEDIUM,
    alias: WORKFLOW_ALIASES.IP_DB_SELF_LOCALIZED,
    category: CATEGORIES.THD_FORCE_LOC.SELF_LOCALIZED,
  },
  LOCALIZED_BY_DEFAULT: {
    accuracy: ACCURACIES.LOW,
    alias: WORKFLOW_ALIASES.DEFAULT,
    category: CATEGORIES.THD_FORCE_LOC.DEFAULT,
  },
  LOCALIZED_BY_GPS_MEDIUM: {
    accuracy: ACCURACIES.MEDIUM,
    alias: WORKFLOW_ALIASES.GPS_LOW,
    category: CATEGORIES.THD_FORCE_LOC.AUTO_LOCALIZED,
  },
  LOCALIZED_BY_GPS_LOW: {
    accuracy: ACCURACIES.LOW,
    alias: WORKFLOW_ALIASES.GPS_LOW,
    category: CATEGORIES.THD_FORCE_LOC.AUTO_LOCALIZED,
  },
  THD_STORE_LOCATION: {
    accuracy: ACCURACIES.HIGH,
    alias: WORKFLOW_ALIASES.IP_DB_STORE,
    category: CATEGORIES.THD_FORCE_LOC.AUTO_LOCALIZED,
  },
  KNOWN_LOCATION: {
    accuracy: ACCURACIES.HIGH,
    alias: WORKFLOW_ALIASES.IP_DB_CORPORATE,
    category: CATEGORIES.THD_FORCE_LOC.AUTO_LOCALIZED,
  },
  LOC_HISTORY_BY_IP: {
    accuracy: ACCURACIES.MEDIUM,
    alias: WORKFLOW_ALIASES.IP_DB_HISTORY,
    category: CATEGORIES.THD_FORCE_LOC.AUTO_LOCALIZED,
  },
  LOC_HISTORY_BY_SUBNET: {
    accuracy: ACCURACIES.LOW,
    alias: WORKFLOW_ALIASES.IP_DB_SIMILAR_HISTORY,
    category: CATEGORIES.THD_FORCE_LOC.AUTO_LOCALIZED,
  },
  GEO_LOCATION: {
    accuracy: ACCURACIES.MEDIUM,
    alias: WORKFLOW_ALIASES.IP_DB_VENDOR,
    category: CATEGORIES.THD_FORCE_LOC.AUTO_LOCALIZED,
  },
  DEFAULT_INTERNAL: {
    accuracy: ACCURACIES.LOW,
    alias: WORKFLOW_ALIASES.IP_DB_DEFAULT_INTERNAL,
    category: CATEGORIES.THD_FORCE_LOC.DEFAULT,
  },
  DEFAULT: {
    accuracy: ACCURACIES.LOW,
    alias: WORKFLOW_ALIASES.DEFAULT,
    category: CATEGORIES.THD_FORCE_LOC.DEFAULT,
  },
};

export const WORKFLOWS = {
  DEFAULT: "DEFAULT",
  DEFAULT_INTERNAL: "DEFAULT_INTERNAL",
  GEO_LOCATION: "GEO_LOCATION",
  KNOWN_LOCATION: "KNOWN_LOCATION",
  LOCALIZED_BY_DEFAULT: "LOCALIZED_BY_DEFAULT",
  LOCALIZED_BY_FUZZY_STORE: "LOCALIZED_BY_FUZZY_STORE",
  LOCALIZED_BY_GPS_HIGH: "LOCALIZED_BY_GPS_HIGH",
  LOCALIZED_BY_GPS_LOW: "LOCALIZED_BY_GPS_LOW",
  LOCALIZED_BY_GPS_MEDIUM: "LOCALIZED_BY_GPS_MEDIUM",
  LOCALIZED_BY_STORE: "LOCALIZED_BY_STORE",
  LOCALIZED_BY_ZIPCODE: "LOCALIZED_BY_ZIPCODE",
  LOC_HISTORY_BY_IP: "LOC_HISTORY_BY_IP",
  LOC_HISTORY_BY_SUBNET: "LOC_HISTORY_BY_SUBNET",
  THD_STORE_LOCATION: "THD_STORE_LOCATION",
};

export const EXTERNAL_USERS = [
  WORKFLOWS.LOC_HISTORY_BY_IP,
  WORKFLOWS.LOC_HISTORY_BY_SUBNET,
  WORKFLOWS.GEO_LOCATION,
  WORKFLOWS.DEFAULT,
];

export const INTERNAL_USERS = [
  WORKFLOWS.KNOWN_LOCATION,
  WORKFLOWS.THD_STORE_LOCATION,
  WORKFLOWS.DEFAULT_INTERNAL,
];

export const TIMESPANS = {
  SESSION: 0,
  FIVE_MINUTES: 5 * 60 * 1000,
  ONE_HOUR: 60 * 60 * 1000,
  ONE_YEAR: 365 * 24 * 60 * 60 * 1000,
  SIX_HUNDRED_DAYS: 600 * 24 * 60 * 60 * 1000,
};